import 'scss/services/businessCardRecg.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { config } from 'config'

$(function () {
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).data('packageId')
    let params = {
      wareId: '1106',
      packageId: packageId,
      serviceName: '名片识别',
      businessId: 'business_card'
    }
    goServiceBuy(params)
  })
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/businessCardRecg.js